import React, { ReactNode, useContext } from 'react';
import classNames from 'classnames';

import { ModalContext } from 'context/modal';

import CloseButton24 from 'components/shared/SVG/CloseButton24';

import styles from './styles.module.scss';

interface AlertProps {
  children: ReactNode;
  className?: string;
  shouldShowCloseIcon?: boolean;
  centerAlign?: boolean;
}

function Alert({ children, className = '', shouldShowCloseIcon = true, centerAlign }: AlertProps) {
  const { hideModal } = useContext(ModalContext);

  return (
    <div className={className}>
      {shouldShowCloseIcon && (
        <button className={styles.iconWrapper} type="button" onClick={hideModal}>
          <CloseButton24 data-testid="Close" />
        </button>
      )}
      <div
        className={classNames(styles.alert, {
          [styles.center]: centerAlign,
        })}
      >
        {children}
      </div>
    </div>
  );
}

export default Alert;
